import type { RouteObject } from 'react-router-dom';

/**
 * Public /app: the member app's download page, outside the signed-in shell. Every invite
 * and app link the CRM sends points here.
 */
export const getAppRoutes: RouteObject[] = [
  { path: 'app', lazy: async () => ({ Component: (await import('./GetAppPage')).GetAppPage }) },
];
